import React from 'react';
import type { IntlShape } from 'react-intl-next';
import { defineMessages } from 'react-intl-next';

import type { ADFEntity } from '@atlaskit/adf-utils/types';
import Image from '@atlaskit/image';
import { fg } from '@atlaskit/platform-feature-flags';

import { CARDS_EXTENSION_KEY, CARDS_EXTENSION_TYPE } from '@atlassian/cards-extension';
import {
	cardsHubElementThumbnail,
	cardsHubElementThumbnailDark,
} from '@atlassian/company-hub-common/assets';

import type { HubElement } from '../hub-element-placeholder/config-panel/hubElementType';

import { linkCardsParameters } from './edit/LinkCardsManifest';

const i18n = defineMessages({
	cardsTitle: {
		id: 'custom-sites-extensions.cards.hub-element.title',
		defaultMessage: 'Cards',
		description: 'A visible text label to be used as the title for the cards element',
	},
	cardsDescription: {
		id: 'custom-sites-extensions.cards.hub-element.description',
		defaultMessage: 'Present links, images and more',
		description: 'A visible text label to be used as the description for the cards element',
	},
});

const getDefaultCardsNodeAdf = (intl: IntlShape): ADFEntity => {
	const { formatMessage } = intl;

	return {
		type: 'extension',
		attrs: {
			extensionKey: CARDS_EXTENSION_KEY,
			extensionType: CARDS_EXTENSION_TYPE,
			parameters: linkCardsParameters(
				formatMessage(i18n.cardsTitle),
				fg('company_hub_cards_autoscroll'),
				fg('company_hub_cards_visual_update'),
				fg('company_hub_cards_v2'),
			),
		},
	};
};
const thumbnailImage: React.ReactNode = (
	<Image src={cardsHubElementThumbnail} srcDark={cardsHubElementThumbnailDark} alt="" />
);

export const linkCardsHubElement: HubElement = {
	extensionKey: CARDS_EXTENSION_KEY,
	title: i18n.cardsTitle,
	description: i18n.cardsDescription,
	Image: thumbnailImage,
	getNodeAdf: getDefaultCardsNodeAdf,
};
